import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { RegistrationService } from '../../services/registration.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  adminNotificationForm: FormGroup;
  admUserDetails: any;
  meritListData: any;
  otpData: any;
  meritId: any;
  courseListData: any;
  sessionListData: any;
  streamListData: any;
  genderListData: any;
  paidListData: any;
  count: any;
  responseMsg: any;
  whatsAppList = [];
  displayOTPDialog: boolean = false;
  displayNotificationDialog: boolean = false;
  invalidShow: boolean = false;


  // for OTP timer
  showTimer: boolean = true;
  timerMinutes: number = 1;
  timerSeconds: number = 0;
  interval: any;
  otpNum: any;

  constructor(private registrationService: RegistrationService,
    private router: Router, private spinner: NgxSpinnerService) {
    this.admUserDetails = JSON.parse(localStorage.getItem('admLoginDetails'));
  }

  ngOnInit() {
    this.otpNum = '';
    this.spinner.show();
    this.adminNotificationForm = new FormGroup({
      stream: new FormControl(0),
      course: new FormControl(0),
      shift: new FormControl(0),
      mlid: new FormControl(null, [Validators.required]),
      gender: new FormControl(0),
      paidid: new FormControl(0),
    });

    // Merit list service call
    this.registrationService.getNotifyInit(this.admUserDetails.token).then((res) => {
      // console.log(res)
      if (res.status === 'success') {
        this.spinner.hide();
        this.meritListData = res.meritlist;
        this.courseListData = res.courselist;
        this.sessionListData = res.shiftlist;
        this.streamListData = res.streamlist;
        this.genderListData = res.genderlist;
        this.paidListData = res.paidlist;
        ;

      } else {
        alert(res.status + ':' + 'Something went wrong');
      }
    });
  }

  showCount() {
    const courseId = this.adminNotificationForm.value.course;
    const sessionId = this.adminNotificationForm.value.shift;
    const streamId = this.adminNotificationForm.value.stream;
    const genderId = this.adminNotificationForm.value.gender;
    const paidId = this.adminNotificationForm.value.paidid;
    this.meritId = this.adminNotificationForm.value.mlid;
    // console.log(this.meritId)
    if (this.meritId != null) {
      this.spinner.show();
      this.registrationService.getNotifyShowCount(streamId, courseId, sessionId, genderId, this.meritId, paidId, this.admUserDetails.token).then((res) => {
        // console.log(res);
        this.count = res.showcount;
        this.spinner.hide();
        alert("Applicant Count :  " + this.count)
      });
    }
    else {
      this.invalidShow = true;
    }
  }


  submit() {
    this.spinner.show();
    this.meritId = this.adminNotificationForm.value.mlid;
    // Call OTP Service when press submit
    if (this.adminNotificationForm.valid) {
      this.registrationService.getNotifySendOTP(this.admUserDetails.token).then((res) => {
        // console.log(res);
        if (res.status === 'success') {
          this.spinner.hide();
          this.otpData = res.otp;
          this.displayOTPDialog = true;
          this.showTimer = true;
          this.startTimer();
        } else {
          alert(res.status + ':' + 'Something went wrong');
        }
      });
    }
    else {
      this.invalidShow = true;
    }
    this.spinner.hide();
  }

  startTimer() {
    this.timerMinutes = 1;
    this.timerSeconds = 0;
    this.interval = setInterval(() => {
      if (this.timerMinutes === 0 && this.timerSeconds === 0) {
        this.stopTimer();
      }

      if (this.timerSeconds === 0) {
        this.timerMinutes--;
        this.timerSeconds = 59;
      } else {
        this.timerSeconds--;
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
    this.showTimer = false;
    this.displayOTPDialog = false;
    this.timerMinutes = 0;
    this.timerSeconds = 0;
  }

  submitOTP() {
    this.spinner.show();
    let value = this.otpNum.replace(/\D/g, '');
    let otpVal = parseInt(value, 10);
    const courseId = this.adminNotificationForm.value.course;
    const sessionId = this.adminNotificationForm.value.shift;
    const streamId = this.adminNotificationForm.value.stream;
    const genderId = this.adminNotificationForm.value.gender;
    const paidId = this.adminNotificationForm.value.paidid;
    if (otpVal === parseInt(this.otpData)) {
      this.registrationService.getNotifySendMSG(streamId, courseId, sessionId, genderId, this.meritId, otpVal, paidId, this.admUserDetails.token).then((res) => {
        // console.log(res);
        this.responseMsg = res.message;
        if (res.status == "success") {
          this.whatsAppList = res.whatsapplst;
          if (this.whatsAppList.length > 0) {
            this.whatsAppList.forEach(item => {
              const whatsapp_no = item.whatsapp_no;
              const whatsapp_template = item.whatsapp_template;
              const whatsapp_body1 = item.whatsapp_body1;
              const whatsapp_body2 = item.whatsapp_body2;
              const whatsapp_body3 = item.whatsapp_body3;
              const whatsapp_body4 = item.whatsapp_body4;
              this.registrationService.pushWpMsgForAdmin(whatsapp_no, whatsapp_template, whatsapp_body1, whatsapp_body2, whatsapp_body3, whatsapp_body4)
                .then((res) => {
                })
                .catch((error) => {
                  console.error('Error:', error);
                  if (error.error && error.error.message) {
                    console.error('Server message:', error.error.message);
                  }
                });

            });
          }
        }
        this.spinner.hide();
        this.displayNotificationDialog = true;
        setTimeout(() => {
          this.displayNotificationDialog = false;
        }, 3000);
        this.stopTimer();
        this.displayOTPDialog = false;
      });
      this.otpNum = '';
    }
    else {
      alert("OTP does not match");
      this.otpNum = '';
      this.spinner.hide();
      this.displayOTPDialog = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/notification/notification.component.ts